import React from 'react';
import { Link } from 'react-router-dom';

const TopBanner = () => {
  return (
    <div className="bg-gradient-to-r from-purple-600 to-indigo-600 text-white py-3">
      <div className="container mx-auto px-4 text-center flex flex-col md:flex-row items-center justify-center gap-4">
        <p className="text-sm md:text-base font-medium">
          Biztonságos digitális jövő a NIS2 megfelelőséggel
        </p>
        <Link 
          to="/kapcsolat"
          className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 px-4 py-1 rounded-full text-sm transition-all duration-300"
        >
          Ingyenes NIS2 konzultáció
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
          </svg>
        </Link>
      </div>
    </div>
  );
};

export default TopBanner; 